<script>
import 'swiper/dist/js/swiper'
import 'swiper/dist/css/swiper.css'
import Swiper from 'swiper'

import MenuBar from '../components/MenuBar.vue'

import { getAtlasDetail } from '@/api/partyTop'
import { imgPath } from '@/utils/filters'

export default {
  components: {
    MenuBar,
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  data() {
    // eslint-disable-next-line no-unused-vars
    const _self = this
    return {
      swiperData: [],
      swiper: null,
      swiperCurrentIndex: 0,
      currentAdminiName: '',
      choseLevelId: 0,
      townshipParam: '',
      imgViewerVisible: false,
      imgList: []
    }
  },
  watch: {
    swiperCurrentIndex(newVal) {
      this.$nextTick(() => {
        setTimeout(() => {
          const parent = document.querySelector('.swiper-menu-box')
          parent.scrollLeft = 136 * newVal - 146
        }, 200)
      })
    }
  },
  created() {
    const { adminiName = '', choseLevelId = 0, townshipParam = '' } = this.$route.query
    if (adminiName && choseLevelId) {
      this.currentAdminiName = adminiName
      this.choseLevelId = choseLevelId
      this.townshipParam = townshipParam
      this.initPageData()
    }
  },
  methods: {
    initSwiper() {
      this.swiper = new Swiper('#swiper-container-honor', {
        direction: 'horizontal', // 垂直切换选项(horizontal/vertical)
        // mousewheel: true, // 滚轮
        // autoplay: {
        //   delay: 2500,
        //   disableOnInteraction: false // 手动操作轮播图后不会暂停
        // },
        effect: 'coverflow', // 切换效果(3d流)
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        preloadImages: false,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true
        },
        // pagination: { // 如果需要分页器
        //   el: '.swp-pagination-honor',
        //   clickable: false // 分页器是否可以点击
        // },
        // navigation: { // 前进后退按钮
        //   nextEl: '.swiper-button-next.swp-button-next-honor',
        //   prevEl: '.swiper-button-prev.swp-button-prev-honor'
        // },
        loop: true, // 循环模式选项
        // loopAdditionalSlides: 1,
        on: {
          init: () => {
            // console.log('swiper init')
          },
          slideChange: () => {
            // console.log('slideChange', this.swiper.realIndex)
            this.swiperCurrentIndex = this.swiper.realIndex
          }
        },
        activeIndexChange: swiper => {
          // console.log('activeIndexChange', swiper)
        }
      })
    },

    onChangeSwiper(direction) {
      direction === 'pre' ? this.swiper.slidePrev(300) : this.swiper.slideNext(300)
      // console.log('page', this.swiper.realIndex)
    },
    onChangeSwiperNum() {
      this.swiper.slideToLoop(0, 300)
    },

    onMenuItemClick(i) {
      this.swiper.slideToLoop(i, 300)
    },
    onPreviewImg(v, type) {
      const currentImgsFir = type === 'old' ? imgPath(v.oldImg) : imgPath(v.newImg)
      const currentImgsSec = type === 'old' ? imgPath(v.newImg) : imgPath(v.oldImg)
      const lastImgs = [currentImgsFir, currentImgsSec]
      this.swiperData.forEach(item => {
        if (item.id !== v.id) {
          lastImgs.push(imgPath(item.oldImg))
          lastImgs.push(imgPath(item.newImg))
        }
      })
      this.imgList = lastImgs
      this.imgViewerVisible = true
      const m = e => e.preventDefault()
      document.body.style.overflow = 'hidden'
      document.addEventListener('touchmove', m, false) // 禁止页面滑动
    },
    closeImgViewer() {
      this.imgViewerVisible = false
      const m = e => e.preventDefault()
      document.body.style.overflow = 'auto'
      document.removeEventListener('touchmove', m, true)
    },

    initPageData() {
      const params = {
        village: this.currentAdminiName,
        status: this.choseLevelId,
        township: this.townshipParam
      }
      getAtlasDetail(params).then(res => {
        if (res.code === 0) {
          if (res.msg.length > 0) {
            this.swiperData = res.msg || []

            this.$nextTick(() => {
              this.initSwiper()
            })
          }
        }
      })
    }
  }
}
</script>

<template>
  <div class="page-container">
    <menu-bar />
    <el-image class="hy-logo" :src="require('imgs/partyTop/hy-logo.png')" alt="hy-logo" />

    <div class="honor-container">
      <div class="narrow narrow-pre" @click="onChangeSwiper('pre')">
        <i class="el-icon-arrow-left" />
      </div>
      <!-- Swiper -->
      <div id="swiper-container-honor" class="swiper-container">
        <div class="swiper-wrapper">
          <div
            v-for="(v, i) in swiperData"
            :key="`swiper-item-${i}`"
            class="swiper-slide"
          >
            <div class="cut-line"></div>
            <div class="old-img-box" @click="onPreviewImg(v, 'old')">
              <img class="swiper-img old-img" :src="v.oldImg | imgPath" alt="oldImg">
              <p class="tip">远年</p>
              <p class="headline">{{ v.oldheadline }}</p>
            </div>
            <div class="new-img-box" @click="onPreviewImg(v, 'new')">
              <img class="swiper-img new-img" :src="v.newImg | imgPath" alt="newImg">
              <p class="tip">近岁</p>
              <p class="headline">{{ v.headline }}</p>
            </div>
          </div>
        </div>
        <!-- Add Pagination -->
        <!-- <div class="swiper-pagination swp-pagination-honor"></div> -->
        <!-- Add Arrows -->
        <!-- <div class="swiper-button-next swp-button-next-honor"></div>
        <div class="swiper-button-prev swp-button-prev-honor"></div> -->
      </div>
      <div class="narrow narrow-next" @click="onChangeSwiper('next')">
        <i class="el-icon-arrow-right" />
      </div>
    </div>

    <div class="swiper-menu">
      <div class="swiper-menu-box">
        <div
          v-for="(v, i) in swiperData"
          :key="`swiper-menu-item-${i}`"
          class="swiper-menu-item"
          :class="{'swiper-menu-item-active': i === swiperCurrentIndex}"
          @click="onMenuItemClick(i)"
        >
          <div class="cut-line"></div>
          <el-image class="swiper-menu-img old-img" :src="v.oldImg | imgPath" alt="oldImg" fit="cover" />
          <el-image class="swiper-menu-img new-img" :src="v.newImg | imgPath" alt="newImg" fit="cover" />
        </div>
      </div>
    </div>

    <div class="pager-container">
      <p class="pager-container-item" @click="onChangeSwiper('pre')">上一页</p>
      <p class="pager-container-item" @click="onChangeSwiper('next')">下一页</p>
      <!-- <p @click="onChangeSwiperNum">第一张</p> -->
    </div>

    <el-image-viewer
      v-if="imgViewerVisible"
      :on-close="closeImgViewer"
      :url-list="imgList"
    />
  </div>
</template>

<style lang="scss" scoped>
.page-container {
  width: 100%;
  min-height: 100vh;
  background: url('~imgs/partyTop/atlas-detail-bg.webp') no-repeat center;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .hy-logo {
    position: absolute;
    top: 26px;
    left: 26px;
    width: 87px;
    height: 50px;
  }
}
.honor-container {
  width: 1200px; // 984px
  height: 560px;
  // margin: 0 auto;
  margin-top: 100px;
  display: flex;
  align-items: center;
  .narrow {
    width: 45px;
    height: 87px;
    border: 2px solid #E4A178;
    background-color: #B6020F;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    i {
      color: #fff;
      font-weight: bold;
      font-size: 26px;
    }
  }
}
#swiper-container-honor {
  width: 984px; // 100%
  padding-top: 50px;
  padding-bottom: 50px;
  .swiper-wrapper {
    width: 100%;
    height: 100%;
  }
}
#swiper-container-honor .swiper-slide {
  width: 884px;
  height: 560px;
  visibility: hidden;
  display: flex;
  position: relative;
  .cut-line {
    position: absolute;
    top: 0;
    left: 440px;
    width: 3px;
    height: 560px;
    background-color: #fff;
    box-shadow: 2px 0px 10px 0px rgba(28,0,0,0.5);
    border-radius: 1px;
    z-index: 10;
  }
  .old-img-box, .new-img-box {
    width: 442px;
    height: 560px;
    .swiper-img {
      width: 442px;
      height: 560px;
      object-fit: cover;
    }
    .tip {
      width: 67px;
      height: 31px;
      border-radius: 6px;
      text-align: center;
      line-height: 31px;

      font-size: 16px;
      font-weight: bold;
      color: #fff;
    }
    .headline {
      position: absolute;
      left: 15px;
      bottom: 15px;
      width: 412px;
      height: 64px;
      background-color: rgba(0, 0, 0, .3);
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 18px;
      box-sizing: border-box;

      font-size: 15px;
      font-weight: bold;
      color: #fff;
      line-height: 29px;
    }
  }
  .old-img-box {
    position: relative;
    .old-img {
      position: absolute;
      top: 0;
      left: 0;
      filter: sepia(80%);
      -webkit-filter: sepia(80%);
    }
    .tip {
      position: absolute;
      top: 22px;
      left: 22px;
      background-color: rgba(0, 0, 0, .3);
    }
  }
  .new-img-box {
    position: relative;
    .new-img {
      position: absolute;
      top: 0;
      left: 0;
    }
    .tip {
      position: absolute;
      top: 22px;
      right: 22px;
      background-color: rgba(0, 0, 0, .3);
    }
  }
  /* .old-img {
    border-radius: 10px 0 0 10px;
  }
  .new-img {
    border-radius: 0 10px 10px 0;
  } */
}
#swiper-container-honor
.swiper-slide.swiper-slide-prev,
#swiper-container-honor .swiper-slide.swiper-slide-next,
#swiper-container-honor .swiper-slide.swiper-slide-active{visibility: visible;}

.swiper-menu {
  width: 1296px;
  height: 148px;
  background: url('~imgs/partyTop/swiper-menu-bg.webp') no-repeat center;
  background-size: 100% 100%;
  margin-top: 40px;
  display: flex;
  align-items: center;
  .swiper-menu-box {
    margin-left: 70px;
    width: 1186px;
    // height: 148px;
    height: 100%;
    display: flex;
    align-items: center;
    column-gap: 11px;
    box-sizing: border-box;
    overflow-x: scroll;
    scroll-behavior: smooth;
    // overflow-y: hidden;
    &::-webkit-scrollbar { // chrome/safari
      display: none;
    }
    scrollbar-width: none; // firefox
    -ms-overflow-style: none; // IE10+
  }
  .swiper-menu-item {
    width: 136px;
    height: 80px;
    display: flex;
    position: relative;
    cursor: pointer;
    border: 2px solid #fff;
    box-sizing: border-box;
    transition: all linear .4s;
    .cut-line {
      position: absolute;
      top: 0;
      left: 66px;
      width: 2px;
      height: 76px;
      background-color: #fff;
      box-shadow: 2px 0px 10px 0px rgba(28,0,0,0.5);
      border-radius: 1px;
      z-index: 10;
    }
    .swiper-menu-img {
      width: 68px;
      height: 76px;
    }
  }
  .swiper-menu-item-active {
    transform: scale(1.2);
    margin: 0 10px 0 14px;
    border: 2px solid #A3000D;
    box-shadow: 0 0 10px rgba(163, 0, 13, .7);
  }
}

.pager-container {
  display: flex;
  column-gap: 10px;
  margin-top: 20px;
  .pager-container-item {
    width: 113px;
    height: 40px;
    background: url('~imgs/partyTop/prev.png') no-repeat center;
    background-size: 100% 100%;
    text-align: center;
    line-height: 40px;
    font-size: 15px;
    font-weight: bold;
    color: #A3000D;
    cursor: pointer;
  }
  .pager-container-item:nth-child(2) {
    background: url('~imgs/partyTop/next.png') no-repeat center;
    background-size: 100% 100%;
    color: #FEFEFE;
  }
}
</style>
